const prefix = 'urn';
const namespace = 'sfextslot';
const modalNamespace = 'sfmodal';
const owner = 'storage-plugin-pilet';
/**
 * @deprecated
 * Seems to be a misunderstanding that Blocks can be used as extension slots
 * interchangeably, so there is now cross-pilet tech debt related to function
 * parameters.
 */
const blockNamespace = `${prefix}:sfblock:storage`;
const drawerNamespace = 'sfdrawer';
export const storageExtensionSlots = {
    FilesTable: `${prefix}:${namespace}:${owner}:file-table`,
    /**
     * @deprecated
     * This is a View Engine block intended to be used by View Engine.
     * Use as an extension slot is not encouraged, since behavior
     * cannot be guaranteed independent of View configuration.
     */
    viewListBlock: `${blockNamespace}:view:list`,
    Download: `${prefix}:${namespace}:${owner}:download`,
    Count: `${prefix}:${namespace}:${owner}:count`,
    ProjectTab: `${prefix}:${namespace}:${owner}:project:tabs:storage`,
    ProjectTile: `${prefix}:${namespace}:${owner}:project:home:tiles:storage`,
    RecentlyDeletedTab: `${prefix}:${namespace}:${owner}:project:recently-deleted:storage-tab`,
    /**
     * @deprecated
     * This component is not used in View Engine and does not meet Block restrictions.
     * Use `storageExtensionSlots.FileViewerExtension` instead.
     */
    FileViewerBlock: `${blockNamespace}:file-viewer`,
    FileViewerExtension: `${prefix}:${namespace}:${owner}:file-viewer`,
    EditOnline: `${prefix}:${namespace}:${owner}:edit:online`,
    EditDesktop: `${prefix}:${namespace}:${owner}:edit:desktop`,
    ShareModal: `${prefix}:${namespace}:${owner}:share`,
    LinkToContainers: `${prefix}:${namespace}:${owner}:linkToContainer`,
    FileViewerDrawer: `${prefix}:${drawerNamespace}:${owner}:file-viewer-drawer`,
    /**
     * @deprecated
     * This component is not used in View Engine and does not meet Block restrictions.
     * Use `storageExtensionSlots.StorageZoneDropDown` instead.
     */
    StorageZoneDropDownBlock: `${blockNamespace}:storage-zone-dropdown`,
    StorageZoneDropDown: `${prefix}:${drawerNamespace}:${owner}:storage-zone-dropdown`,
    /**
     * @deprecated
     * This component is not used in View Engine and does not meet Block restrictions.
     * Use `storageExtensionSlots.WorkflowsStorageZoneDropDown` instead.
     */
    WorkflowsStorageZoneDropDownBlock: `${blockNamespace}:domino:storage-zone-dropdown`,
    WorkflowsStorageZoneDropDown: `${prefix}:${drawerNamespace}:${owner}:domino:storage-zone-dropdown`,
    MoveCopy: `${prefix}:${namespace}:${owner}:move-copy`,
};
export const storagePiletModelKeys = {
    ImportFromStorageProvider: `${prefix}:${modalNamespace}:${owner}:import-from-storage-provider`,
};
//# sourceMappingURL=extensionTypes.js.map